import { createFileRoute, Outlet } from '@tanstack/react-router'

/** One run and its payslips (which sit under the run's crumb). */
export const Route = createFileRoute('/_app/payroll/runs/$runId')({
  staticData: { crumb: 'payrollRun' },
  component: Outlet,
})
